<div class="import-container" *ngIf="isBlackboard">
  <div class="import-upload-container">
    <h1 class="app-heading app-heading-1">
      {{ 'archive_import_heading' | translation }}
    </h1>
    <p class="app-text app-text-1" [innerHTML]="'archive_import_description_html' | translation | safeHtml">
    </p>
    <p class="app-text-danger">
      <span
        ><i class="fa-solid fa-triangle-exclamation" *ngIf="errorMessage"></i>
        {{ errorMessage }}</span
      >
    </p>
    <div class="import-frame">
      <app-file-upload
        [autoUpload]="false"
        [canUpload]="canUpload"
        (uploadStarted)="handleUploadStarted()"
        (uploaded)="handleFileUpload($event)"
        (uploadComplete)="handleUploadComplete($event)"
        acceptedFileTypes=".zip"
        [allowMultiple]="false"
        key="archive-import"></app-file-upload>
    </div>
  </div>
  <div class="course-imports-container">
    <h2>{{ 'archive_import_course_imports' | translation }}</h2>
    <app-course-imports
      [filterType]="'zip-archive'"
      [customColumns]="customColumns"
      [refreshTrigger]="refreshTrigger"></app-course-imports>
  </div>
</div>
